import { v4 as uuidv4 } from 'uuid';
// Error that is caused by a client and should be reported to the client
export class SimpleError extends Error {
    constructor(error) {
        var _a;
        super(error.message);
        this.code = error.code;
        this.message = error.message;
        this.human = error.human;
        this.field = error.field;
        this.statusCode = error.statusCode;
        this.id = (_a = error.id) !== null && _a !== void 0 ? _a : this.generateID();
        this.meta = error.meta;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SimpleError);
        }
    }
    toString() {
        return this.code + ': ' + this.message + (this.field ? ' at ' + this.field : '') + ' (' + this.id + ')';
    }
    /**
     * Required to override the default toJSON behaviour of Error
     */
    toJSON() {
        return this.encode({ version: 0 });
    }
    encode(context) {
        return {
            id: this.id,
            code: this.code,
            message: this.message,
            human: this.human,
            field: this.field,
            meta: this.meta,
        };
    }
    static decode(data) {
        var _a, _b, _c;
        return new SimpleError({
            id: data.field('id').string,
            code: data.field('code').string,
            message: data.field('message').string,
            human: (_a = data.optionalField('human')) === null || _a === void 0 ? void 0 : _a.string,
            field: (_b = data.optionalField('field')) === null || _b === void 0 ? void 0 : _b.string,
            meta: (_c = data.optionalField('meta')) === null || _c === void 0 ? void 0 : _c.value,
        });
    }
    hasCode(code) {
        return this.code === code;
    }
    getCode(code) {
        if (this.hasCode(code)) {
            return this;
        }
    }
    hasFieldThatStartsWith(prefix) {
        return !!this.field && this.field.startsWith(prefix);
    }
    doesMatchFields(fields) {
        for (const field of fields) {
            if (this.doesMatchField(field)) {
                return true;
            }
        }
        return false;
    }
    doesMatchField(field) {
        if (!this.field) {
            return false;
        }
        return this.field.startsWith(field);
    }
    generateID() {
        return uuidv4() + '@' + new Date().getTime();
    }
    addNamespace(field) {
        this.field = this.field ? field + '.' + this.field : field;
    }
    /// Returns a human description of all the errors
    getHuman() {
        var _a;
        return (_a = this.human) !== null && _a !== void 0 ? _a : this.message;
    }
}
export function isSimpleError(e) {
    return e !== null && typeof e === 'object' && 'string' && 'code' in e && 'message' in e && typeof e.code === 'string' && typeof e.message === 'string' && 'encode' in e && 'doesMatchFields' in e && 'doesMatchField' in e;
}
//# sourceMappingURL=SimpleError.js.map